<template>
  <RouterView />
  <GlobalLoginModal />
  <GlobalPaymentModal />
</template>
